// Logo Escapafy Business — dos variantes:
// - LIGHT_BG: original (navy/oro sobre fondo blanco) → usar en secciones de fondo claro (cream/blanco) con mix-blend-mode: multiply
// - DARK_BG: nuevo (plata/blanco sobre fondo negro) → usar en secciones de fondo oscuro (navy/black) con mix-blend-mode: screen
// Estas técnicas eliminan el "recuadro" del fondo del PNG y dejan el logo flotando limpio.
export const BUSINESS_LOGO_LIGHT_BG =
  "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/dg3s9l8s_escapafy_biz.png";

export const BUSINESS_LOGO_DARK_BG =
  "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/70zcqlz6_ChatGPT%20Image%209%20jun%202026%2C%2008_40_03.png";

// Backward compatibility (some imports might still use this)
export const BUSINESS_LOGO = BUSINESS_LOGO_LIGHT_BG;

// Curated Unsplash editorial — NO faces.
export const BUSINESS_PHOTOS = {
  hero: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=1920&q=85",
  meeting: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1600&q=85",
  hotel: "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=1600&q=85",
  desk: "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?auto=format&fit=crop&w=1200&q=85",
  office: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1600&q=85",
  hallway: "https://images.unsplash.com/photo-1604328698692-f76ea9498e76?auto=format&fit=crop&w=1600&q=85",
  // Founder portrait — Mercè
  founder: "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/qg086e21_ChatGPT%20Image%209%20jun%202026%2C%2009_16_03.png",
};

export const BUSINESS_CONTACT = {
  email: "hola@escapafy.com",
  whatsapp: "+34644088078",
  linkedin: "https://www.linkedin.com/company/escapafy",
  instagram: "https://www.instagram.com/escapafy",
};
